import { connect } from "react-redux";

import {
  createRouteControlPoint as onCreateRouteControlPoint,
  deleteRouteControlPoint as onDeleteRouteControlPoint,
} from "./../../actions/routeControlPointActions";

const mapStateToProps = (state) => ({
  createRouteControlPointDataState: state.routeControlPoint.createRouteControlPointDataState,
  deleteRouteControlPointDataState: state.routeControlPoint.deleteRouteControlPointDataState,
});

const mapDispatchToProps = { onCreateRouteControlPoint, onDeleteRouteControlPoint };

const withRouteControlPoint = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withRouteControlPoint };
